import { useTranslation } from 'react-i18next';
import { useNotification } from '@topcon/topcon-utils';

import ConfirmDeletionModal from '../../../components/Modal/ConfirmDeletionModal';
import { useDeleteIdentityProvider } from './identityProviders.mutations';
import { IdentityProviderBody } from '../../../api/generated/pap';

interface Props {
  identityProvider: IdentityProviderBody;
  open: boolean;
  onClose: (shouldUpdate: boolean) => void;
}

function DeleteIdentityProviderModal({ identityProvider, open, onClose }: Props) {
  const notificationService = useNotification();
  const { t } = useTranslation('settings');
  const { mutateAsync: deleteIdentityProvider, isPending: isDeleting } =
    useDeleteIdentityProvider();

  const handleDelete = async () => {
    await deleteIdentityProvider(identityProvider.id, {
      onSuccess: () => {
        onClose(true);
      },
      onError: () => {
        notificationService.addNotification(
          t('identityProviders.identityProviderDeletionFailure'),
          t('identityProviders.identityProviderDeletionFailureDescription', {
            name: identityProvider.name,
          }),
          'error'
        );
      },
    });
  };

  return (
    <ConfirmDeletionModal
      title={t('identityProviders.confirmIdentityProviderDeletion')}
      description={t('identityProviders.identityProviderDeletionDescription')}
      text={identityProvider.name}
      subText={identityProvider.OIDCConfig?.authURL}
      primaryButtonText={t('identityProviders.deleteIdentityProvider')}
      iconName="portrait"
      open={open}
      onSubmit={handleDelete}
      onClose={onClose}
      loading={isDeleting}
    />
  );
}

export default DeleteIdentityProviderModal;
